import { render, staticRenderFns } from "./AdminShell.vue?vue&type=template&id=32121073&"
import script from "./AdminShell.vue?vue&type=script&lang=ts&"
export * from "./AdminShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports